<div class="container-fluid edit-page">
    <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 pr-0 pl-0">
            <div class="card">
                <div class="card-body">
                    <!-- HEADER -->
                    <div class="tw:!my-6 tw:flex tw:items-center tw:justify-between">
                        <div class="tw:flex tw:cursor-pointer tw:gap-4">
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 ">{{ 'SALES_LIST_PAGE.sales' | translate }}</h3>
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="./payments">
                                {{ 'SALES_LIST_PAGE.payments' | translate }}
                            </h3>
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="./commissions">
                                {{ 'SALES_LIST_PAGE.commissions' | translate }}
                            </h3>
                        </div>

                        <div class="tw:hidden tw:md:block tw:flex-shrink-0">
                            <button class="btn btn-md btn-primary" (click)="newPayment()">
                                {{ 'GENERAL.new' | translate }}
                                <i class="material-icons icon">add</i>
                            </button>
                        </div>
                    </div>

                    <form
                        [formGroup]="searchForm"
                        class="tw:mb-6 tw:flex tw:flex-col tw:items-end tw:md:items-center tw:justify-between tw:gap-4 tw:md:flex-row"
                        [class.tw:opacity-50]="loading()"
                        [class.tw:pointer-events-none]="loading()"
                    >
                        <div class="tw:w-full tw:md:w-2/5">
                            <app-text-input
                                formControlName="search"
                                [hasMarginB]="false"
                                icon="search"
                                [hasMarginB]="false"
                                placeholder="{{ 'SALES_LIST_PAGE.filterFieldPlaceholder' | translate }}"
                            />
                        </div>
                        
                        <div class="tw:flex tw:justify-between tw:gap-4">
                            @if (currentUser()?.role !== 'provider' && availableUsers()?.length > 1) {
                                <div dropdown container="body" placement="bottom right">
                                    <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                        {{ searchForm.value?.createdByUser?.name || ('SALES_LIST_PAGE.allUsers' | translate) }}
                                        <i class="material-icons icon">group</i>
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" (click)="setCreatedByUser(null)">
                                                {{ 'SALES_LIST_PAGE.allUsers' | translate }}
                                            </a>
                                        </li>
                                        @for (user of availableUsers(); let i = $index; track i) {
                                            <li>
                                                <a class="dropdown-item" (click)="setCreatedByUser(user)">
                                                    {{ user.name }}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            }
                            <div dropdown container="body" placement="bottom right">
                                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                    {{ searchForm.value?.status?.label || ('SALES_LIST_PAGE.state' | translate) }}
                                    <i class="material-icons icon">arrow_drop_down</i>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" (click)="setSaleStatuses(null)">
                                            {{ 'GENERAL.all' | translate }}
                                        </a>
                                    </li>
                                    @for (status of saleStatuses; let i = $index; track i) {
                                        <li>
                                            <a class="dropdown-item" (click)="setSaleStatuses(status)">
                                                {{ status.label }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                            <div dropdown container="body" placement="bottom right">
                                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                    @if (selectedDateRange().value === 'custom') {
                                        {{ searchForm.value.startDate | date: 'shortDate' }} - {{ searchForm.value.endDate | date: 'shortDate' }}
                                    } @else {
                                        {{ selectedDateRange().label }}
                                    }

                                    <i class="material-icons icon">arrow_drop_down</i>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu">
                                    @for (range of filterDateRanges; let i = $index; track i) {
                                        <li>
                                            <a class="dropdown-item" (click)="setDateRange(range)">
                                                {{ range.label }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </form>

                    @if (loading()) {
                        <app-loader />
                    } @else {
                        <!-- TOTALS  -->
                        @if (salesData().sales.length) {
                            <div class="tw:mb-6 tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4 tw:overflow-x-auto">
                                <div class="tw:flex tw:justify-start tw:gap-8">
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.totalSales }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.sales' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.totalPaid | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.paid' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.totalPending | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.toPay' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.totalCommissions | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.totalCommissions' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.totalAmountWithoutCommissions | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.totalAmountWithoutCommissions' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.cancelledAmount | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.cancelled' | translate }}</div>
                                    </div>
                                    <div class="tw:min-w-[70px] tw:text-primary">
                                        <h6 class="tw:!text-2xl tw:!font-bold">{{ salesData().summary.netAmount | merchantCurrency }}</h6>
                                        <div class="tw:text-xs">{{ 'GENERAL.total' | translate }}</div>
                                    </div>
                                </div>
                                <div dropdown container="body" placement="bottom right">
                                    <button dropdownToggle class="btn btn-md tw:!text-primary" type="button">
                                        {{ 'GENERAL.options' | translate }}
                                        <i class="material-icons icon">arrow_drop_down</i>
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu">
                                        @if (isInvoicingActive()) {
                                            <a
                                                class="dropdown-item tw:!flex tw:items-center tw:justify-between"
                                                cdkMenuItem
                                                menuOptions
                                                (click)="downloadAll()"
                                            >
                                                {{ 'SALES_LIST_PAGE.downloadAll' | translate }} <i class="material-icons icon ml-2">file_download</i>
                                            </a>
                                        }
                                        <a
                                            class="dropdown-item tw:!flex tw:items-center tw:justify-between"
                                            cdkMenuItem
                                            menuOptions
                                            (click)="exportXLS()"
                                        >
                                            {{ 'SALES_LIST_PAGE.exportXLS' | translate }} <i class="material-icons icon ml-2">file_download</i>
                                        </a>
                                    </ul>
                                </div>
                            </div>
                        }
                        @if (salesData().sales.length === 0) {
                            <!-- Empty satate -->
                            <div class="empty-state">
                                <div class="text-center">
                                <div class="tw:rounded-full tw:w-12 tw:h-12 tw:bg-primary-50 tw:flex tw:items-center tw:justify-center tw:mx-auto mb-3">
                                    <i class="material-icons tw:text-primary-300">view_list</i>
                                </div>
                                <p class="text-secondary tw:mb-3">{{ 'SALES_LIST_PAGE.emptyState.description' | translate }}</p>
                                </div>
                            </div>
                        } @else {
                            <!-- TABLE  -->
                            <div class="tw:w-full tw:overflow-x-auto">
                                <div class="tw:table tw:table-auto tw:w-full tw:min-w-[640px]">
                                    <div class="tw:table-header-group">
                                        <div class="tw:table-row tw:bg-primary-50 tw:text-xs tw:font-semibold tw:text-neutral-500 tw:shadow-menu">
                                            <div class="tw:table-cell tw:p-2">{{ 'SALES_LIST_PAGE.salesCode' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'SALES_LIST_PAGE.nameVat' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'SALES_LIST_PAGE.registeredBy' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'GENERAL.date' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'SALES_LIST_PAGE.totalValue' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'GENERAL.state' | translate }}</div>
                                            <!-- <div class="tw:table-cell tw:p-2">*DEBUG*</div> -->
                                            <div class="tw:table-cell tw:p-2 text-center">{{ 'GENERAL.options' | translate }}</div>
                                        </div>
                                    </div>

                                    <div class="tw:table-row-group tw:py-2 tw:text-xs tw:text-neutral-500 tw:min-w-[640px]">
                                        @for (line of salesData().sales; let i = $index; track line.lineKind + '-' + line.id) {
                                            <div
                                                class="tw:table-row tw:shadow-menu tw:cursor-pointer tw:hover:bg-neutral-50 tw:transition-colors"
                                                [class.tw:bg-primary-50]="i % 2 == 1"
                                                (click)="seeDetails(line)"
                                            >
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    @if (line.lineKind === 'cancellation') {
                                                        @if (line.creditNoteReferences?.length) {
                                                            @for (reference of line.creditNoteReferences; track reference) {
                                                                <div class="tw:text-primary-500">{{ reference }}</div>
                                                            }
                                                        } @else {
                                                            <span class="tw:text-primary-500">{{ line.code || '-' }}</span>
                                                        }
                                                    } @else {
                                                        <span class="tw:text-primary-500">
                                                            {{ line.invoiceReference || line.code || '-' }}
                                                        </span>
                                                    }
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    @if (line.clientName) {
                                                        <div>{{ line.clientName }}</div>
                                                    } @else {
                                                        <div class="tw:italic tw:text-neutral-400">{{ 'GENERAL.walkInCustomer' | translate }}</div>
                                                    }
                                                    @if (line.clientVatNumber) {
                                                        <div>{{ line.clientVatNumber }}</div>
                                                    }
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">{{ (line.lineKind === 'cancellation' ? line.cancelledByUser?.name : line.createdByUser?.name) || '-' }}</div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    <div>{{ (line.lineKind === 'cancellation' ? line.cancelledAt : line.createdAt) | date: 'dd/MM/yyyy' }}</div>
                                                    <div>{{ (line.lineKind === 'cancellation' ? line.cancelledAt : line.createdAt) | date: 'HH:mm' }}</div>
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    @if (line.lineKind === 'cancellation') {
                                                        <span class="tw:text-error-800">{{ -line.total | merchantCurrency }}</span>
                                                    } @else {
                                                        {{ line.total | merchantCurrency }}
                                                    }
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    <app-sales-status [sale]="displaySale(line)" />
                                                </div>
                                                <!-- <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    *{{line.status}}*{{line.invoiceStatus || 'null'}}*{{line.invoicingWasActiveAtCreation ? 'new' : 'old'}}*
                                                </div> -->
                                                <div class="tw:table-cell tw:p-2 text-center" (click)="$event.stopPropagation()">
                                                    <div dropdown container="body" placement="bottom right">
                                                        <button dropdownToggle class="btn btn-md" type="button">
                                                            <i class="material-icons icon">more_horiz</i>
                                                        </button>
                                                        <ul *dropdownMenu class="dropdown-menu">
                                                            <a
                                                                class="dropdown-item tw:!flex tw:items-center tw:justify-between"
                                                                cdkMenuItem
                                                                menuOptions
                                                                (click)="seeDetails(line)"
                                                            >
                                                                {{ 'SALES_LIST_PAGE.seeDetails' | translate }}
                                                                <i class="material-icons icon ml-2">receipt</i>
                                                            </a>
                                                            @if (line.lineKind !== 'cancellation' && line.invoicePdfUrl) {
                                                                <a
                                                                    class="dropdown-item tw:!flex tw:items-center tw:justify-between"
                                                                    cdkMenuItem
                                                                    menuOptions
                                                                    (click)="emailInvoice(line)"
                                                                >
                                                                    {{ 'SALES_LIST_PAGE.emailInvoice' | translate }}
                                                                    <i class="material-icons icon ml-2">mail_outline</i>
                                                                </a>
                                                                <a
                                                                    class="dropdown-item tw:!flex tw:items-center tw:justify-between"
                                                                    cdkMenuItem
                                                                    menuOptions
                                                                    (click)="downloadInvoice(line)"
                                                                >
                                                                    {{ 'SALES_LIST_PAGE.downloadInvoice' | translate }}
                                                                    <i class="material-icons icon ml-2">file_download</i>
                                                                </a>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<button type="button" class="btn-action book-mobile visible-mobile" (click)="newPayment()">
    <i class="material-icons icon nom">add</i>
</button>
